// DonateBanner.jsx
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";
import PayPalDonateSdkButton from "./PayPalDonateSdkButton";
import { getHost } from "./config";

const DonateBanner = () => {
  const authToken =
    typeof window !== "undefined" ? localStorage.getItem("authToken") : null;

  return (
    <div className="donate-banner w-100">
      <div className="donate-banner-inner container-fluid px-3 py-2">
        <p className="donate-banner-msg mb-0 small">
          Στήριξε το teachers-app.com και βοήθησε να συνεχίσουμε την προσπάθειά μας.
        </p>
        <div className="donate-banner-paypal">
          <PayPalDonateSdkButton
            authToken={authToken}
            getHost={getHost}
            compact
            donationSource="banner"
          />
        </div>
      </div>
    </div>
  );
};

export default DonateBanner;
